/**
 * DateRangeInput Component
 *
 * Date range picker for BETWEEN operator with date/timestamp fields.
 * Returns [startDate, endDate] as ISO string tuple.
 */

import { DatePicker } from 'antd'
import dayjs, { Dayjs } from 'dayjs'

const { RangePicker } = DatePicker

interface DateRangeInputProps {
  value?: string
  value2?: string
  onChange: (value: string | null, value2: string | null) => void
  placeholders?: [string, string]
}

export function DateRangeInput({
  value,
  value2,
  onChange,
  placeholders = ['Start date', 'End date'],
}: DateRangeInputProps) {
  // Convert string values to dayjs objects
  const dayjsValue: [Dayjs | null, Dayjs | null] = [
    value ? dayjs(value) : null,
    value2 ? dayjs(value2) : null,
  ]

  // Handle change and convert back to ISO strings
  const handleChange = (dates: [Dayjs | null, Dayjs | null] | null) => {
    if (!dates || dates.length !== 2) {
      onChange(null, null)
      return
    }

    const [startDate, endDate] = dates

    // Store as ISO strings (YYYY-MM-DD format for dates)
    onChange(
      startDate ? startDate.format('YYYY-MM-DD') : null,
      endDate ? endDate.format('YYYY-MM-DD') : null
    )
  }

  return (
    <RangePicker
      value={dayjsValue}
      onChange={handleChange}
      placeholder={placeholders}
      style={{ width: '100%' }}
      format="YYYY-MM-DD"
    />
  )
}
